module.exports = __webpack_public_path__ + "assets/img/link_myhome_btn.a1ba2f32.svg";